<mat-toolbar color="primary" class="header">
    <div class="left-section">
        <img [src]="logo" alt="App Logo" class="app-logo" />
        @if (showPoweredBy) {
            <span class="powered-by">Powered by Perse&trade;</span>
        }
    </div>
    <div class="center-section">
        @if (isUserLoggedIn$ | async) {
            <span class="app-title">Perse Insights</span>
        }
    </div>
    <div class="right-section">
        @if (isUserLoggedIn$ | async) {
            <span class="user-name">{{ userName }}</span>
            <button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="notification-button">
                <mat-icon>account_circle</mat-icon>
            </button>
            <mat-menu #notificationMenu="matMenu">
                @if (availableDashboards$ | async; as dashboards) {
                    @if (dashboards.length > 1) {
                        @for (dashboard of dashboards; track dashboard.route) {
                            @if (!dashboard.isActive) {
                                <button mat-menu-item (click)="onSwitchDashboard(dashboard.route)">
                                    <mat-icon>dashboard</mat-icon>
                                    <span>{{ dashboard.label }}</span>
                                </button>
                            }
                        }
                        <mat-divider></mat-divider>
                    }
                }
                <button mat-menu-item (click)="onLogout()">
                    <mat-icon>logout</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>
        }
    </div>
</mat-toolbar>